import { render, staticRenderFns } from "./sidebar-margin-splits.vue?vue&type=template&id=712ffd9a&scoped=true"
import script from "./sidebar-margin-splits.vue?vue&type=script&lang=js"
export * from "./sidebar-margin-splits.vue?vue&type=script&lang=js"
import style0 from "./sidebar-margin-splits.vue?vue&type=style&index=0&id=712ffd9a&prod&lang=scss&scoped=true"
import style1 from "./sidebar-margin-splits.vue?vue&type=style&index=1&id=712ffd9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712ffd9a",
  null
  
)

export default component.exports